import { searchProductsQueryOptions, searchShopProductsQueryOptions } from '~/queries';
import { recommendProductsOptions } from '../_queries';

export const defaultSearchShopProductsQueryOptions = (shopId: string) =>
  searchShopProductsQueryOptions(
    {
      page: 0,
      size: 6,
      shopId,
    },
    { enabled: Boolean(shopId) },
  );

export const defaultSearchCategoryProductsQueryOptions = (categoryId: string, pid: number) =>
  searchProductsQueryOptions(
    {
      page: 0,
      size: 36,
      ref: 'category',
      categoryId: [categoryId],
      sort: 'create_date_desc',
      filters: false,
      excludePid: [pid],
    },
    { enabled: Boolean(categoryId) },
  );

export const defaultRecommendProductsQueryOptions = (pid: number) => recommendProductsOptions({ pid: pid.toString() });
